import request from '@/utils/request'

// 数据列表
export const getRoleLists = (data) => {
    return request({
        url: '/role/lists',
        params: data
    })
}

// 数据选项列表
export const getRoleOptionLists = (data) => {
    return request({
        url: '/role/option/lists',
        params: data
    })
}

// 详情
export const getRoleDetail = (id) => {
    return request({
        url: `/role/${id}`
    })
}

// 修改
export const putRole = (data) => {
    return request({
        url: '/role/manage',
        method: 'PUT',
        data
    })
}

// 添加
export const addRole = (data) => {
    return request({
        url: '/role/manage',
        method: 'POST',
        data
    })
}

// 删除
export const delRole = (id) => {
    return request({
        url: `/role/${id}`,
        method: 'DELETE'
    })
}

// 根据角色id获取权限节点数

export const getAuthByRoleId = (id) => {
    return request({
        url: `/role/auths/${id}`,
        method: 'GET'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/role/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/role/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/role/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
